import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import './App.css';
import Home from './components/Home/Home/Home';
import 'bootstrap/dist/css/bootstrap.min.css';
import ProjectDetails from './components/Home/ProjectDetails/ProjectDetails';
import Header from "./components/shared/Header/Header";
import Footer from "./components/shared/Footer/Footer";
import Blog from "./components/Blog/Blog";

function App() {
  return (
    <div>
      <Router>
        <Header></Header>
        <Switch>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route exact path="/home">
            <Home></Home>
          </Route>
          <Route path="/blog">
            <Blog></Blog>
          </Route>
          <Route exact path="/projects/:id">
            <ProjectDetails></ProjectDetails>
          </Route>

        </Switch>
        <Footer></Footer>
      </Router>
    </div>
  );
}

export default App;
